@if (canToggle()) {
<!-- eslint-disable-next-line 
  @angular-eslint/template/click-events-have-key-events, 
  @angular-eslint/template/interactive-supports-focus -->
<div class="label" (click)="toggle()">
  <div class="wrapper">
    <fa-icon [icon]="icons.faCaretRight" class="expansion-indicator"></fa-icon>
    <span>{{item().label}}</span>
  </div>
</div>
}
@else {
<div class="label no-interaction">
  <div class="wrapper">
    <span>{{item().label}}</span>
  </div>
</div>
}

<div expandable [expanded]="expanded()">
  <ul link-tree [items]="item().children" [depth]="childDepth()"></ul>
</div>